import r, { forwardRef as s } from "react";
import { ark as p } from "@ark-ui/react";
import { styled as o } from "@huspy/styled-system/jsx";
import { css as c } from "@huspy/styled-system/css";
import { input as m, inputLabel as u, inputDescription as f } from "@huspy/styled-system/recipes";
const l = o(p.input, m), I = ({ icon: t, iconPosition: e = "right" }) => t ? /* @__PURE__ */ r.createElement(
  p.span,
  {
    className: c({
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      left: e === "left" ? "3" : "initial",
      right: e === "right" ? "3" : "initial"
    })
  },
  t
) : null, h = s((t, e) => {
  const { icon: a, iconPosition: n, ...i } = t;
  return a ? /* @__PURE__ */ r.createElement(p.span, { className: c({ position: "relative", width: "100%" }) }, /* @__PURE__ */ r.createElement(
    l,
    {
      pl: n === "left" ? "8" : i.pl,
      pr: n === "right" ? "8" : i.pr,
      ref: e,
      ...i
    }
  ), /* @__PURE__ */ r.createElement(I, { icon: a, iconPosition: n })) : /* @__PURE__ */ r.createElement(l, { ...i });
}), E = o(p.textarea, m), D = s((t, e) => /* @__PURE__ */ r.createElement(E, { ref: e, ...t, height: "auto" })), b = o("label", u), d = s(
  ({ children: t, isRequired: e, ...a }, n) => /* @__PURE__ */ r.createElement(b, { ...a, ref: n }, t, e ? " *" : "")
), g = o("p", f);
h.displayName = "Input";
d.displayName = "InputLabel";
g.displayName = "InputDescription";
export {
  l as BaseInput,
  b as BaseLabel,
  h as Input,
  g as InputDescription,
  d as InputLabel,
  D as TextArea
};
